import {
    FETCH_BUILDINGS_LIST,
    SAVE_BUILDING,
    DELETE_BUILDING,
    FETCH_FLOORS_LIST,
    FETCH_FLOOR_LIST,
    FETCH_FLOOR_PLAN,
    SAVE_FLOOR,
    DELETE_FLOOR,
    FETCH_ROOMS_LIST,
    FETCH_ROOM_LIST,
    SAVE_ROOM,
    DELETE_ROOM,
} from '../actions/types'

const INITIAL_STATE = {
    buildingsList: [],
    floorsList: [],
    lists: [],
    floorPlan: [],
    roomsList: [],
    floors: [],
    rooms: [],
    buildingPagination: {
        currentPage: 1,
        totalPages: 0
    },
    buildingParams: {},
    floorPagination: {
        currentPage: 1,
        totalPages: 0
    },
    floorParams: {},
    roomPagination: {
        currentPage: 1,
        totalPages: 0
    },
    roomParams: {},
}

let calculateTotalPages = (totalCount, pageSize) => {
    return (totalCount && pageSize) ? (Math.floor(totalCount / pageSize) + (totalCount % pageSize ? 1 : 0)) : 1
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_BUILDINGS_LIST:
            return {
                ...state,
                lists: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                buildingsList: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                buildingPagination: {
                    currentPage: action.payload.current_page,
                    totalPages: calculateTotalPages(action.payload.total_count, action.payload.page_size)
                   },
                buildingParams: action.param
            }
        case SAVE_BUILDING:
            return {...state, buildingsList: [ action.payload, ...state.buildingsList] };
        case DELETE_BUILDING:
            return{...state, buildingsList: [...state.buildingsList.filter( val=>val.id !== action.payload.data)]}
        case FETCH_FLOORS_LIST:
            const floors = []
            const list_filter = state.lists
            list_filter.forEach(val => val.floors.forEach(a => {
                if (a.building === parseInt(action.payload)) {
                    floors.push(a)
                }
                return false
            }))
            return {
                ...state,
                floorsList: floors,
                roomsList: []
            }
        case FETCH_FLOOR_PLAN:
            return {
                ...state,
                floorPlan: action.payload
            }
        case FETCH_ROOMS_LIST:
            const rooms = []
            const lists_filter = state.floorsList
            const floor_list = lists_filter.filter(val => val.id === parseInt(action.payload.floor))
            floor_list.forEach(val => val.locations.forEach(a => rooms.push(a)))
            return {
                ...state,
                roomsList: rooms
            }
        case FETCH_FLOOR_LIST:
            return {
                ...state,
                floors: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                floorPagination: {
                    currentPage: action.payload.current_page,
                    totalPages: calculateTotalPages(action.payload.total_count, action.payload.page_size)
                   },
                floorParams: action.param
            }
        case SAVE_FLOOR:
            return {...state, floors: [ action.payload, ...state.floors] };
        case DELETE_FLOOR:
            return{...state, floors: [...state.floors.filter( val=>val.id !== action.payload.data)]}
        case FETCH_ROOM_LIST:
            return {
                ...state,
                rooms: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                roomPagination: {
                    currentPage: action.payload.current_page,
                    totalPages: calculateTotalPages(action.payload.total_count, action.payload.page_size)
                   },
                roomParams: action.param
            }
        case SAVE_ROOM:
            return {...state, rooms: [ action.payload, ...state.rooms] };
        case DELETE_ROOM:
            return {...state, rooms: [...state.rooms.filter( val=>val.id !== action.payload.data)]}
        default:
            return state
    }
}